module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./DetailView.js"));
	}, "PunishDetailView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=PunishDetailView!./src/pages/Promote/BusinessHall/Punish/Detail/DetailView.js
// module id = 1151
// module chunks = 431